export default __webpack_public_path__ + "static/pattern-c82c4f3136dde53e6adb3a97f682fd49.png";